import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Column, TextInput } from '@resurs/midas-react'
import { midas } from '@resurs/midas'
import { Conditional } from '@resurs/react-utils'
import Page from '../../../internal/Page'
import SettingsPanel from '../../../internal/SettingsPanel'
import { getText } from '../../../internal/TextLabels'
import { Countries } from '../../../models/countries'
import { getPaymentInfo as fetchPaymentInfo } from '../../../store/actions/settings-actions'
import { useOnMount } from '../../../util/utility-hooks'

const renderLine = (tag, value) => {
  return (
    <>
      <Column col4>
        <label className={midas.formLabel}>
          {getText(`paymentSettings.paymentInformation.${tag}`)}
        </label>
      </Column>
      <Column col8>
        <div style={{ width: '100%' }}>
          <TextInput id={tag} disabled skipValidation value={value || ''} />
        </div>
      </Column>
    </>
  )
}

const PaymentInformation = ({
  getPaymentInfo,
  storeId,
  paymentInfo,
  countryCode,
}) => {
  useOnMount(() => {
    getPaymentInfo(storeId)
  })

  const getBankAccountNumber = () => {
    return paymentInfo.externalClearing
      ? `${paymentInfo.externalClearing} ${paymentInfo.externalAccount}`
      : ''
  }

  return (
    <Page>
      <SettingsPanel
        header={getText('paymentSettings.paymentInformation.header')}
      >
        <Conditional
          when={countryCode}
          anyOf={[Countries.NO, Countries.FI, Countries.SE]}
        >
          {renderLine('bankgiro', paymentInfo.bankGiro)}
        </Conditional>

        <Conditional
          when={countryCode}
          anyOf={[Countries.NO, Countries.FI, Countries.SE]}
        >
          {renderLine('plusgiro', paymentInfo.plusGiro)}
        </Conditional>
        <Conditional
          when={countryCode}
          anyOf={[Countries.DK, Countries.NO, Countries.FI, Countries.SE]}
        >
          {renderLine('bankAccount', getBankAccountNumber())}
        </Conditional>
        <Conditional
          when={countryCode}
          anyOf={[Countries.DK, Countries.NO, Countries.FI, Countries.SE]}
        >
          {renderLine('iban', paymentInfo.iban)}
        </Conditional>
        <Conditional
          when={countryCode}
          anyOf={[Countries.NO, Countries.FI, Countries.SE]}
        >
          {renderLine('bic', paymentInfo.bic)}
        </Conditional>
      </SettingsPanel>
    </Page>
  )
}

PaymentInformation.propTypes = {
  getPaymentInfo: PropTypes.func.isRequired,
  paymentInfo: PropTypes.object.isRequired,
  storeId: PropTypes.number.isRequired,
  countryCode: PropTypes.oneOf(Object.values(Countries)).isRequired,
}

const mapDispatchToProps = dispatch => ({
  getPaymentInfo: storeId => {
    dispatch(fetchPaymentInfo(storeId))
  },
})

const mapStateToProps = state => ({
  countryCode: state.storeInfo.currentStore.country,
  storeId: state.storeInfo.currentStore.accountSystemStoreId,
  paymentInfo: state.settings.paymentInfo,
})

export default connect(mapStateToProps, mapDispatchToProps)(PaymentInformation)
